import { QueryParamRecord } from '@/bundles/App/type';

/**
 * Find difference between two objects
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Object} difference
 * */
export function objectDiff(obj1: any, obj2: any) {
  return Object.keys(obj2).reduce((diff, key) => {
    if (obj1[key] === obj2[key]) return diff
    return {
      ...diff,
      [key]: obj2[key]
    }
  }, {});
}

/**
 * Find difference between tro arrays
 * @param {Array} arr1
 * @param {Array} arr2
 * @return {Array} difference
 * */
export function arrayDiff(arr1: any[], arr2: any[]) {
  return arr1.filter(item => !arr2.includes(item))
}

/**
 * Generate paramString base on array of params
 * @param {any[]} params
 * @return {string}
 * */
export function generateParams (params: QueryParamRecord[]) {
  return params.length ? params.map((param, index) => {
    let query = index === 0 ? '?' : '&'
    query += `${param.name}=`
    query += typeof param.value === 'string' || typeof param.value === 'boolean' || typeof param.value === 'number' ? param.value : param.value.join(',')
    return query
  }).reduce((accum, item) => accum + item) : ''
}
